import { GraphQLError } from "graphql";

type ErrorMessage = {
  key?: string;
  message: string;
  errorCode?: string;
  data: Record<string, any>; // TODO: This type should maybe be generic? and optional :thinking: :mvi 2021-12-07
};

type GraphQLThrownError = Error & { graphQLErrors: GraphQLError[] };

export const getValidationErrors = (
  error: Error | GraphQLThrownError,
): Record<string, string[]> => {
  const errors: Record<string, string[]> = {};

  if (!("graphQLErrors" in error)) {
    return { general: [error.message] };
  }

  error.graphQLErrors.forEach((graphQLError) => {
    try {
      const errorMessages: ErrorMessage | ErrorMessage[] = JSON.parse(
        graphQLError.message,
      );

      if (!Array.isArray(errorMessages)) {
        const resolvedKey = errorMessages.key || "general";
        errors[resolvedKey] = errors[resolvedKey] || [];
        errors[resolvedKey].push(errorMessages.message);
        return;
      }

      errorMessages.forEach(({ key, message }) => {
        const resolvedKey = key || "general";
        errors[resolvedKey] = errors[resolvedKey] || [];
        errors[resolvedKey].push(message);
      });
    } catch (e) {
      errors.general = errors.general || [];
      errors.general.push(graphQLError.message);
    }
  });

  return errors;
};

export const getUnifiedValidationErrors = (
  error: Error | GraphQLThrownError,
): string[] => {
  try {
    const validationErrors = getValidationErrors(error || []);

    const errorValues = Object.values(validationErrors);
    const allErrors = errorValues.reduce(
      (acc, errors) => [...acc, ...errors],
      [],
    );

    return allErrors;
  } catch (e) {
    throw error;
  }
};

export const getDetailedValidationErrors = (
  error: Error | GraphQLThrownError,
): ErrorMessage[] => {
  if (!("graphQLErrors" in error)) {
    return [{ message: error.message, data: {} }];
  }

  const errors = error.graphQLErrors.flatMap((graphQLError) => {
    const errorMessage: ErrorMessage[] = JSON.parse(graphQLError.message);
    return errorMessage;
  });

  return errors;
};
